
const MEMPACKALL_LIST = 'MEMPACKALL_LIST';
const MEMPACKALL_PAGE = 'MEMPACKALL_PAGE';
const MEMPACKALL_CONDITION = 'MEMPACKALL_CONDITION';

const MempackageDetailModel = function () {
  const name = 'MempackageDetail';
  return {
    name,
    state: {
      list: [],
      condition: {
        status:1,
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: MEMPACKALL_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: MEMPACKALL_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: MEMPACKALL_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = MempackageDetailModel.state.list, action) => {
        if (action.type === MEMPACKALL_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = MempackageDetailModel.state.page, action) => {
        if (action.type === MEMPACKALL_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = MempackageDetailModel.state.condition, action) => {
        if (action.type === MEMPACKALL_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
    }
  };
}();

export default MempackageDetailModel;


// WEBPACK FOOTER //
// ./src/models/MempackageDetailModel.js